export default __webpack_public_path__ + "5aa73b4e2ef6a651b3ec6b255aa3e17b.png";